<template>
  <div class="dod-container" v-if="!loading">
    <dod-view-title :title="'Opiekunowie'" />
    <dod-search-input
      :withMonthSwitcher="true"
      :with-filters="true"
      :filter-settings="['EMPLOYEE_STATUS', 'DEPARTMENT', 'SCOPE_OF_CARE']"
      @search="handleSearch"
      @onFilter="handleFilters"
      @onMonthChange="onMonthChange"
      :date="date"
    />
    <div class="export-bar">
      <custom-button
        :size="'small'"
        :customStyles="'height: 40px;padding: 0 1rem;margin:0; width: fit-content'"
        :title="exporting ? 'Generowanie...' : 'Pobierz listę (XLSX)'"
        :disabled="exporting || !(employees.meta && employees.meta.total > 0)"
        @click="exportToXls"
      />
    </div>
    <pagination-arrows
      v-if="employees.meta"
      :onPage="employees.meta.per_page"
      :pageNumber="employees.meta.current_page"
      :total="employees.meta.total"
      @nextPage="handleNextPage"
      @previousPage="handlePreviousPage"
    />

    <table
      class="table table-striped"
      v-if="employees && employees.data && employees.data.length > 0"
    >
      <thead>
        <tr>
          <td>ID</td>
          <td>Data utworzenia</td>
          <td>Opiekun</td>
          <td>Status</td>
          <td>Adres</td>
          <td>Numer telefonu</td>
          <td>Ilość godz. zaplanowanych</td>
          <td>Ilość godz. wykonanych</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="employee in employees.data" :key="employee.id">
          <td>{{ employee.id }}</td>
          <td>{{ formatDate(employee.createdAt) }}</td>
          <td>{{ employee.firstName }} {{ employee.lastName }}</td>
          <td>{{ employee.status }}</td>
          <td>{{ employee.address }}</td>
          <td>{{ employee.phone }}</td>
          <td>{{ employee.numberOfHours || 0 }}</td>
          <td>{{ employee.numberOfMadeHours || 0 }}</td>
          <td>
            <gradient-button
              @handleClick="moveToEmployeeDetails(employee.id)"
              :title="'Przejdź'"
              :customStyles="'width: 5vw; font-size: calc(11px + 0.05vw);'"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <dod-empty-list v-else />
  </div>
</template>

<script>
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import moment from "moment";
import GradientButton from "../../components/dod/GradientButton.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import shared from "../../shared";
import PaginationArrows from "../../components/PaginationArrows.vue";
import CustomButton from "../../components/CustomButton.vue";

const defaultLimit = 20;

export default {
  components: {
    DodViewTitle,
    DodSearchInput,
    GradientButton,
    DodEmptyList,
    PaginationArrows,
    CustomButton,
  },
  name: "DODEmployeesList",

  data() {
    return {
      loading: true,
      month: "",
      year: "",
      filters: {},
      search: "",
      date: "",
      limit: defaultLimit,
      page: 1,
      exporting: false,
    };
  },

  async mounted() {
    const now = moment();
    this.date = now.toDate();
    this.month = now.get("month") + 1;
    this.year = now.get("year");
    await this.fetchEmployees();
    this.loading = false;
  },

  methods: {
    async handleNextPage() {
      this.page++;
      await this.fetchEmployees();
    },
    async handlePreviousPage() {
      this.page--;
      await this.fetchEmployees();
    },

    async fetchEmployees() {
      await this.$store.dispatch("getDodEmployeesInMonth", {
        search: this.search,
        filters: this.filters,
        month: this.month,
        year: this.year,
        limit: this.limit,
        page: this.page,
      });
    },
    formatDate(date) {
      return shared.dateToDayMonthYearFormat(date);
    },

    // Pobiera CAŁĄ listę (wszystkie strony) dla wybranego miesiąca, wyszukiwania i filtrów.
    async exportToXls() {
      this.exporting = true;
      try {
        const response = await this.$store.dispatch(
          "generateEmployeesXlsxReport",
          {
            month: this.month,
            year: this.year,
            search: this.search,
            filters: this.filters,
          }
        );
        const fileURL = window.URL.createObjectURL(new Blob([response]));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `opiekunowie_${this.year}_${String(this.month).padStart(2, "0")}.xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się wygenerować pliku XLS",
        });
      } finally {
        this.exporting = false;
      }
    },

    async onMonthChange(date) {
      const dateToSet = moment(date);
      this.date = dateToSet.toDate();
      this.month = dateToSet.get("month") + 1;
      this.year = dateToSet.get("year");
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchEmployees();
    },
    async handleSearch(searchValue) {
      this.search = searchValue;
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchEmployees();
    },

    async handleFilters(filters) {
      this.filters = {};
      if (filters) {
        filters.forEach((filter) => (this.filters[filter.key] = filter.value));
      }
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchEmployees();
    },

    moveToEmployeeDetails(employeeId) {
      this.$router.push({
        name: "DodEmployeeDetails",
        params: { id: employeeId },
      });
    },
  },
  computed: {
    employees() {
      return this.$store.getters.getDodEmployeesInMonth;
    },
  },
};
</script>

<style scoped>
table {
  table-layout: fixed;
  font-size: calc(11px + 0.05vw);
}
.export-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}
</style>